import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProductCard } from '../components/ProductCard';
import { BenefitsSection } from '../components/BenefitsSection';
import { SalesLetter } from '../components/SalesLetter';
import { BundleOffer } from '../components/BundleOffer';
import { TestimonialCard } from '../components/TestimonialCard';
import { FormatsSection } from '../components/FormatsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { CountdownTimer } from '../components/CountdownTimer';
import { StickyCartButton } from '../components/StickyCartButton';
import { FloatingContactButton } from '../components/FloatingContactButton';
import { FAQSection } from '../components/FAQSection';
import { SocialProofBanner } from '../components/SocialProofBanner';
import { AnimatedSection } from '../components/AnimatedSection';
import { LiveNotifications } from '../components/LiveNotifications';
export function LandingPage() {
  const products = [{
    title: '30 Noches para Dormir en Paz',
    description: 'Método Latino Emocionalmente Inteligente para calmar tu mente y sanar la ansiedad.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/frud4MZfgNuJRqK3nNtUKy/ChatGPT_Image_2_dic_2025%2C_21_43_14.png',
    formats: ['📱'],
    badge: '⭐ PRINCIPAL'
  }, {
    title: 'Glow Up Bichota',
    description: 'Guía para descubrir tu poder femenino y brillar con confianza auténtica.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/21HbNt2iTtsf4E5L2BWpPV/ChatGPT_Image_17_nov_2025%2C_15_09_22.png',
    formats: ['📱'],
    badge: '🎁 BONO GRATIS'
  }, {
    title: 'Sobrevive a la Quincena',
    description: '50 hacks reales para ahorrar dinero sin sacrificar tu vida.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wDwXrVvpt6pU2qnh8QR7T4/ChatGPT_Image_17_nov_2025%2C_15_09_18.png',
    formats: ['📱'],
    badge: '🎁 BONO GRATIS'
  }];
  const testimonials = [{
    quote: 'Dormí por primera vez en semanas. Este libro cambió mi vida completamente. Ya no tengo miedo a la hora de dormir.',
    author: 'María González',
    location: 'Miami, FL',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  }, {
    quote: 'El método realmente funciona. Me siento más tranquila y descansada cada mañana. Los bonos son increíbles también.',
    author: 'Carolina Ruiz',
    location: 'Los Angeles, CA',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  }, {
    quote: 'Por fin encontré algo que me ayuda con mi ansiedad nocturna. Vale cada centavo y más.',
    author: 'Ana Martínez',
    location: 'Houston, TX',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-318">
      <ScrollProgress data-id="element-319" />
      <CountdownTimer data-id="element-320" />
      <StickyCartButton data-id="element-321" />
      <FloatingContactButton data-id="element-322" />
      <LiveNotifications data-id="element-323" />

      <HeroSection data-id="element-324" />

      <AnimatedSection animation="fade-in" data-id="element-325">
        <SocialProofBanner data-id="element-326" />
      </AnimatedSection>

      {/* What's Included Section */}
      <section className="w-full py-20 bg-white" data-id="element-327">
        <div className="max-w-7xl mx-auto px-6" data-id="element-328">
          <AnimatedSection animation="fade-up" data-id="element-329">
            <div className="text-center mb-16" data-id="element-330">
              <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-331">
                ⭐ Qué Incluye Tu Compra
              </h2>
              <p className="text-xl text-gray-600" data-id="element-332">
                El método completo + 2 bonos digitales GRATIS
              </p>
            </div>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-333">
            {products.map((product, index) => <AnimatedSection key={index} animation="fade-up" delay={index * 100} data-id="element-334">
                <ProductCard {...product} data-id="element-335" />
              </AnimatedSection>)}
          </div>

          <AnimatedSection animation="fade-up" delay={400} data-id="element-336">
            <div className="text-center mt-12" data-id="element-337">
              <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-338">
                <strong className="text-navy-900" data-id="element-339">
                  "30 Noches para Dormir en Paz"
                </strong>{' '}
                es el producto principal. Los otros 2 eBooks son{' '}
                <strong className="text-pink-600" data-id="element-340">
                  bonos completamente GRATIS
                </strong>{' '}
                para acelerar tu transformación.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <AnimatedSection animation="fade-in" data-id="element-341">
        <BenefitsSection data-id="element-342" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-343">
        <SalesLetter data-id="element-344" />
      </AnimatedSection>

      <AnimatedSection animation="scale" data-id="element-345">
        <BundleOffer data-id="element-346" />
      </AnimatedSection>

      {/* Testimonials Section */}
      <section className="w-full py-20 bg-gradient-to-b from-white to-pink-50" data-id="element-347">
        <div className="max-w-7xl mx-auto px-6" data-id="element-348">
          <AnimatedSection animation="fade-up" data-id="element-349">
            <div className="text-center mb-16" data-id="element-350">
              <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-351">
                💬 Lo Que Dicen Nuestras Bichotas
              </h2>
              <p className="text-xl text-gray-600" data-id="element-352">
                Mujeres reales, transformaciones reales
              </p>
            </div>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-353">
            {testimonials.map((testimonial, index) => <AnimatedSection key={index} animation="fade-up" delay={index * 150} data-id="element-354">
                <TestimonialCard {...testimonial} data-id="element-355" />
              </AnimatedSection>)}
          </div>
        </div>
      </section>

      <AnimatedSection animation="fade-in" data-id="element-356">
        <FormatsSection data-id="element-357" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-358">
        <FAQSection data-id="element-359" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-360">
        <GuaranteeSection data-id="element-361" />
      </AnimatedSection>

      <Footer data-id="element-362" />
    </div>;
}